/* treatmentPatternsSlice.ts */

/* Redux-Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

/* Thunks */
import { fetchTreatmentPatterns } from "src/redux/thunks/treatment-patterns/treatmentPatternsThunk";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Interfaces */
import { BaseSliceProps } from "src/shared/interfaces/common/Slice";
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { TreatmentPatternsProps } from "src/shared/interfaces/TreatmentPatterns";

const initialState: BaseSliceProps<
  BaseChartProps<TreatmentPatternsProps[], ChartType[][]>
> = {
  data: undefined,
  isLoading: false,
  modifiedAt: undefined,
  error: undefined,
};

export const treatmentPatternsSlice = createSlice({
  name: "treatmentPatterns",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchTreatmentPatterns.pending,
      (state) => {
        if (!state.data) {
          state.isLoading = true;
          state.error = undefined;
        }
      }
    );
    builder.addCase(
      fetchTreatmentPatterns.fulfilled,
      (
        state,
        action: PayloadAction<
          | BaseChartProps<
              TreatmentPatternsProps[],
              ChartType[][]
            >
          | undefined
        >
      ) => {
        const prevData = state.data;
        state.data = action.payload;

        if (
          prevData &&
          JSON.stringify(prevData) !==
            JSON.stringify(state.data)
        ) {
          state.modifiedAt = new Date().toISOString();
        }

        if (state.data) {
          state.isLoading = false;
          state.error = undefined;
        }
      }
    );
    builder.addCase(
      fetchTreatmentPatterns.rejected,
      (state, action) => {
        state.isLoading = false;
        state.data = undefined;

        const error = action.payload;
        if (!error) return;

        state.error = action.payload;
      }
    );
  },
});

/* Reducer */
export default treatmentPatternsSlice.reducer;
